export default "__VITE_ASSET__Db1YO2Tb__"